import styled from 'styled-components/macro';

export const FurtherNeedRadioWrapper = styled.div<{ showDefault?: boolean }>`
  .jdjFtN {
    position: absolute;
    bottom: ${(props) => (props.showDefault ? '0' : '69px')};
  }
`;
